<template>
  <div class="titled">
    <div
      style="
        width: 1200px;
        margin: auto;
        display: flex;
        justify-content: space-between;
      "
    >
      <div class="title-tab">
        <div v-if="$route.path != '/'">
          <router-link
            style="text-decoration: none; color: #fff"
            :to="{ path: '/' }"
          >
            影音器材库首页
          </router-link>
        </div>
        <div v-else>
          <a style="text-decoration: none; color: #fff" href="">
            影音器材库首页
          </a>
        </div>
        <div style="padding-left: 45px">HI,欢迎来到影音器材库</div>

        <!--<span class="vertical"></span>-->
        <a style="text-decoration: none" href="http://market.hd199.com//"
          ><div style="padding-left: 20px">识货</div></a
        >
        <a style="text-decoration: none" href="http://resell.hd199.com/"
          ><div style="padding-left: 20px">二手</div></a
        >
        <a style="text-decoration: none" href="http://www.hd199.com/"
          ><div style="padding-left: 20px">论坛</div></a
        >
        <a style="text-decoration: none" href="http://www.hd199.net/"
          ><div style="padding-left: 20px">门户</div></a
        >
      </div>
      <div style="padding-left: 45px;" class="logins" v-show="isShowLogin">
        <span style="text-decoration: none; color: #fff;" @click="gologin"
          >请登录</span
        >
      </div>
      <div v-show="!isShowLogin" class="login-me">
        <div style="margin-right: 160px">
          <img
            style="margin-top: 2px"
            class="sweet-heart"
            src="@/assets/gz.png"
            alt=""
          />
          <el-row class="tac">
            <el-col :span="12">
              <el-menu default-active="2" class="el-menu-vertical-demo">
                <el-submenu style="padding: 0" index="1">
                  <template style="padding: 0" slot="title">
                    <span>我的</span>
                  </template>
                  <el-menu-item-group>
                    <el-menu-item @click="myCollect" index="1-1"
                      >我的收藏</el-menu-item
                    >
                    <el-menu-item @click="outLogin" index="1-2"
                      >退出登录</el-menu-item
                    >
                  </el-menu-item-group>
                </el-submenu>
              </el-menu>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!--发布框_beg-->
    <SecondHand :SecondHand.sync="SecondHand"></SecondHand>
    <!--发布框_end-->
  </div>
</template>

<script>
import SecondHand from "@/components/common/SecondHand";
import {
  getCookie,
  clearCookie,
  clearCookieAll,
  removeLoc,
} from "@/common/js/common";
export default {
  name: "Header",
  data() {
    return {
      LoginDialog: false,
      isShowLogin: true,
      SecondHand: false,
    };
  },
  components: {
    SecondHand,
  },
  created() {
    this.isLogin();
  },
  methods: {
    gologin() {
      window.location.href = `http://lt.hd199.com/user/username-login?ershou`;
    },
    isLogin() {
      if (getCookie("sid")) {
        this.isShowLogin = false;
      }
    },
    //  我的收藏
    myCollect() {
      if (this.isShowLogin === false) {
        this.$router.push("/equitment/collect");
      } else {
        this.$message({
          type: "error",
          message: "请先登录",
          onClose: function () {
            window.location.href = `http://lt.hd199.com/user/username-login?ershou`;
          },
        });
      }
    },
    //退出登录
    outLogin() {
      let _this = this;
      _this.$post("/apis/common/logout", {}).then((res) => {
        removeLoc();
        clearCookieAll();
        location.reload();
      });
    },
  },
};
</script>

<style >
.logins{
	line-height: 40px !important;
}
.titled {
  height: 60px;
  width: 100%;
  background: #272727;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title-tab {
  display: flex;
}
.title-tab div {
  color: #fff;
  font-size: 16px;
  line-height: 40px;
}
.el-submenu {
  top: -26px !important;
}
.vertical {
  width: 1px;
  background: #fff;
  opacity: 0.4;
  margin-left: 11px;
}
.login-me {
  color: #fff;
  font-size: 16px;
  display: flex;
  width: 20%;
}
.login-me img {
  height: 14px;
  width: 14px;
}
.login-me div {
  margin-right: 37px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.login-me span {
  margin-left: 8px;
  margin-top: -3px;
  color: #fff;
  font-size: 14px;
  width: 70px;
}
.el-icon-close:before {
  color: black;
}

.el-dialog__header {
  background: #f9be04;
  padding: 16px 20px;
}
.el-textarea__inner {
  height: 150px;
}
.classifys {
  display: flex;
  font-size: 18px;
  color: #303030;
  margin-top: 30px;
  display: flex;
  padding-left: 35px;
  align-items: center;
}
.class-list {
  display: flex;
}
.select {
  border: 1px solid #d3d3d2;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 12px;
  color: #d3d3d2;
  margin-left: 20px;
}
.first-select {
  border: 1px solid #f9be04;
  border-radius: 8px;
  color: #f9be04;
  padding: 0 12px;
}
.el-checkbox__label {
  font-size: 16px;
  color: #bcbcbc;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #f9bf07;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: #f9bf07;
  border-color: #f9c00b;
}
.el-checkbox__inner:hover {
  border-color: #f9c00b;
}
.el-checkbox__input.is-focus.el-checkbox__inner {
  border-color: #f9c00b;
}
.load-button {
  background: #f9c213;
  box-shadow: 0 2px 4px 0 rgba(198, 198, 198, 0.5);
  border-radius: 2px;
  border: none;
  color: #fff;
  width: 110px;
  height: 37px;
  margin-left: 3px;
  font-size: 18px;
}
.el-textarea {
  width: 80%;
}
.dialog-footer {
  display: flex;
  justify-content: center;
}
.dialog-footer button {
  border: none;
  background: #f9c213;
  box-shadow: 0 2px 4px 0 rgba(198, 198, 198, 0.5);
  border-radius: 2px;
  height: 37px;
  width: 142px;
  color: #fff;
  font-size: 18px;
}
.el-submenu {
  position: absolute;
  top: -28px;
  background: #272727;
  width: 110px;
}
.el-menu-item.is-active {
  color: #f9c213;
}
.el-submenu__title:hover {
  background: #272727;
}
.el-submenu__title {
  padding: 0 !important;
}
.el-submenu .el-menu-item {
  padding: 0 !important;
  min-width: 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/equitment/Header.vue